var global = window;

global.formValidation = function (target, includePrivate) {
    var errors = [];
    if (!target) target = $(document);
    else target = $(target);

    let targetApi = target.data('api');
    if (!targetApi) {
        targetApi = target.closest('[data-api]');
        targetApi = targetApi.data('api');
    }

    // inputs
    var inputs = target.find('input, textarea, select, table[name]');
    inputs.each(function () {
        let input = $(this);
        let inputApi = input.closest('[data-api]');
        let inputApiSlug = inputApi.data('api');
        if (inputApiSlug != targetApi) return true;

        if ((!includePrivate && input.parents('.private').length) || input.is(':disabled')) return;

        // fix val
        if (input.data('oldval')) input.val(input.data('oldval'));
        input.data('oldval', '')

        // disabled
        if (input.is(':disabled') || input.hasClass('disabled')) return;

        // Mandatory
        if (input.hasClass('field--mandatory')) {
            if (this.tagName == 'TABLE') {
                var currentRow = input.find('>tbody > tr.selected');
                if (!currentRow.length) {
                    errors.push({
                        field: input,
                        message: 'Vous devez faire un choix',
                    });
                }
            }
            else if (this.type == 'checkbox') {
                if (!this.checked) {
                    errors.push({
                        field: input,
                        message: __('Ce champ est obligatoire'),
                    });
                }
            } else if (input.data('data') && input.data('data').multiple && typeof input.val() == 'object' && !input.val().length) {
                errors.push({
                    field: input,
                    message: __('Vous devez faire au moins un choix'),
                });
            } else if (!input.val()) {
                if (!input.data('use-placeholder') || !prepareValueContent(input.attr('placeholder'))) {
                    errors.push({
                        field: input,
                        message: __('Ce champ est obligatoire'),
                    });
                }
            }
        }

        // Email
        if (input.val() && input.attr('type') == 'email' && !isEmail(input.val())) {
            errors.push({
                field: input,
                message: __('Adresse courriel invalide'),
            });
        }

        // Redundancy
        if (input.data('redundancy')) {
            var redField = $('[name=' + input.data('redundancy') + ']');
            if (input.val() != redField.val()) {
                errors.push({
                    field: input,
                    message: 'Doit correspondre au champ ' + $('.col--field--' + redField.attr('name') + ' label, .col--label--' + redField.attr('name') + ' label').text(),
                });
            }
        }

        // Min / Max
        if (input.data('min')) {
            if ((this.type == 'text') && input.val().length < input.data('min') && input.val()) {
                errors.push({
                    field: input,
                    message: 'Minimum de ' + input.data('min') + ' caractères',
                });
            }
        }
        if (input.data('max')) {
            if ((this.type == 'text') && input.val().length > input.data('max') && input.val()) {
                errors.push({
                    field: input,
                    message: 'Maximum de ' + input.data('max') + ' caractères',
                });
            }
        }

        // test
        if (input.data('test') && input.val() && !input.hasClass('tested--success')) {
            errors.push({
                field: input,
                test: input.data('test'),
            });
        }
    });

    return errors;
}

global.formShowError = function (target, errors) {
    if (!target) target = $(document);
    else target = $(target);

    target.find('.field--error').removeClass('field--error');

    $.each(errors, function (key) {
        if (this.test && !this.field.hasClass('tested--error')) return false;

        this.field.addClass('field--error').attr('title', this.message).attr('placeholder', this.message).change(function () {
            $(this).removeClass('field--error').removeAttr('title').removeAttr('placeholder');
        });

        if (this.field.attr('type') == 'text' || this.field.attr('type') == 'password' || this.field.attr('type') == 'email') {
            var { field } = this;
            if (!field.data('oldval')) field.data('oldval', field.val());
            field.val('');
            setTimeout(function () {
                if (field.data('oldval')) field.val(field.data('oldval'));
                field.data('oldval', '')
            }, 1000)
        }
        
        if (key == 0) {
            global.formFocusField(field);
        }
    })
}

global.formFocusField = function(field) {
    field = $(field);
    field.focus();
    let tab = field.closest('.tabs__pane');
    if (tab.length) {
        inputs.fn.tabs.set(tab, tab);
        tab = tab.parent().closest('.tabs__pane');
        if (tab.length) {
            inputs.fn.tabs.set(tab, tab);
        }
    }
}

global.getFormData = function (target, includePrivate, exclude, include) {
    var data = {};
    if (!target) target = $(document);
    else target = $(target);
    if (!exclude) exclude = [];
    let targetTag = target.get(0).tagName;

    if (targetTag == 'INPUT' || targetTag == 'TEXTAREA' || targetTag == 'SELECT') {
        target = target.parent();
    }

    // inputs
    // console.log('-- input --');
    var inputs = target.find('input');
    inputs.each(function () {
        var input = $(this);

        if (include && !include.includes(this.name)) return;

        if ((!includePrivate && input.parents('.private').length) || input.is(':disabled')) return;

        if (this.name && this.type != 'button') {
            switch (this.type) {
            case 'file':
                if (!data._files) data._files = {};
                if (this.files.length == 1) {
                    data._files[this.name] = this.files[0];
                } else if (this.files.length > 1) {
                    for (const file of this.files) {
                        if (!data._files[this.name]) data._files[this.name] = [];
                        data._files[this.name].push(file);
                    }
                }
                break;
            case 'checkbox':
                // checkbox simple
                if (!$(this).closest('.col--field--checkboxs').length) {
                    if (this.checked) {
                        if (!this.value || this.value == '' || this.value == 'on' || this.value == '1') {
                            data[this.name] = this.value = 1;
                        }
                        else {
                            data[this.name] = prepareValueContent(this.value);
                        }
                    } else {
                        data[this.name] = 0;
                    }
                }
                // checkbox multiple
                else {
                    if (!data[this.name]) {
                        data[this.name] = [];
                    }
                    if (this.checked) {
                        data[this.name].push(prepareValueContent(this.value));
                    }
                }
                break;
            case 'radio':
                if (input.is(':checked')) {
                    data[this.name] = prepareValueContent(this.value);
                }
                break;
            case 'password':
                if (this.value) data[this.name] = prepareValueContent(this.value);
                break;
            default:
                data[this.name] = prepareValueContent(this.value);
                if (!this.value && input.data('use-placeholder')) {
                    data[this.name] = prepareValueContent(input.attr('placeholder'));
                }
                break;
            }
            // force number format
            if ((this.type == 'number' || this.type == 'range') && typeof data[this.name] === 'string') {
                data[this.name] = parseFloat(data[this.name]);
            }
            if (data[this.name] === undefined || data[this.name] === 'undefined') data[this.name] = '';
        }
        // console.log(this.name+' : '+data[this.name]);
    });

    // textarea
    // console.log('-- textarea --');
    var inputs = target.find('textarea');
    inputs.each(function () {
        if (this.name) {
            let input = $(this);
            let currentVal = null;

            if (include && !include.includes(this.name)) return;

            if ((!includePrivate && input.parents('.private').length) || input.is(':disabled')) return;

            if (input.hasClass('txtEditor') || input.parent().hasClass('txtEditor')) {
                currentVal = pluginEditor.get((this.id) ? this.id : input.parent().attr('id'));
            } else if (input.hasClass('codeEditor') || input.parent().hasClass('codeEditor')) {
                currentVal = pluginCode.get((this.id) ? this.id : input.parent().attr('id'));
            }
            else {
                currentVal = this.value
            }
            switch (input.data('format')) {
                case 'conds':
                    if (!currentVal) data[this.name] = [];
                    else {
                        var separator = (input.data('separator')) ? input.data('separator') : ' : ';
                        var itemsRaw = currentVal.split("\n\n");
                        var items = [];
                        $.each(itemsRaw, function () {
                            var subitemRaw = this.split("\n");
                            var subitems = [];
                            $.each(subitemRaw, function () {
                                var subsubitemRaw = this.split(separator);
                                // Split les valeurs à virgules
                                if (subsubitemRaw.length == 3) {
                                    let subsubitemValSplit = subsubitemRaw[2].split(',')
                                    if (subsubitemValSplit.length > 1) {
                                        subsubitemRaw[2] = subsubitemValSplit;
                                    }
                                }
                                subitems.push(subsubitemRaw);
                            });
                            items.push(subitems);
                        });
                        data[this.name] = items;
                    }
                    break;
                case 'items':
                    if (!currentVal) data[this.name] = [];
                    else {
                        var separator = (input.data('separator')) ? input.data('separator') : ' : ';
                        var itemsRaw = currentVal.split("\n");
                        var items = [];
                        $.each(itemsRaw, function () {
                            var itemRaw = this.split(separator);
                            items.push(itemRaw);
                        });
                        data[this.name] = items;
                    }
                    break;
                case 'enum':
                    if (!currentVal) data[this.name] = [];
                    else {
                        var items = currentVal.split(",");
                        data[this.name] = items;
                    }
                    break;
                case 'json':
                    try {
                        var dataJson = JSON.parse(currentVal);
                    } catch (e) {
                        var dataJson = '[]';
                    }
                    data[this.name] = dataJson;
                    break;
                default:
                    data[this.name] = prepareValueContent(currentVal);
                    break;
            }
        }
    });

    // select
    // console.log('-- select --');
    var inputs = target.find('select');
    inputs.each(function () {
        if (this.name) {
            var input = $(this);
            
            if (include && !include.includes(this.name)) return;

            if ((!includePrivate && input.parents('.private').length) || input.is(':disabled')) return;

            if (input.attr('multiple')) {
                data[this.name] = input.val()
            }
            else {
                data[this.name] = prepareValueContent(this.value);
                if (this.value === '' || this.value == 'NULL') {
                    data[this.name] = null;
                }
            }
            // console.log(this.name+' : '+data[this.name]);
        }
    });

    // tabs
    var inputs = target.find('.tabs[name]');
    inputs.each(function () {
        var input = $(this);

        if (include && !include.includes(input.attr('name'))) return;

        if (input.attr('name')) {
            var currentTab = input.find(' > ul .ui-tabs-active');
            // vargroup += "&"+this.name+"="+currentTab.index();
            // vargroup += "&"+this.name+"-value=";
            data[input.attr('name')] = currentTab.index();
            data[input.attr('name') + '-value='] = $('#' + currentTab.attr('aria-controls')).attr('value');
        }
    });

    // table
    var inputs = target.find('table[name]');
    inputs.each(function () {
        var input = $(this);

        if (include && !include.includes(input.attr('name'))) return;
        var currentRow = input.find('>tbody > tr.selected');
        if (input.attr('name') && currentRow) {
            data[input.attr('name')] = currentRow.data('value');
        }
    });

    // find input having target and affect the targets with the visible elements
    var inputs = target.find('input, select, textarea').filter('[data-target]:visible,[data-target][type=hidden]');
    inputs.each(function () {
        var input = $(this);

        if (include && !include.includes(input.data('target'))) return;

        if (input.parent().is(':visible') && input.data('target')) {
            data[input.data('target')] = data[input.attr('name')];
        }
    });

    if (exclude) {
        $.each(exclude, function (key, fieldName) {
            delete data[fieldName];
        })
    }

    return data;
}

global.getFieldData = function (niceName, target) {
    let data = getFormData(target, true, null, [niceName])
    data = data[niceName]
    return data
}

global.prepareValueContent = function (value) {
    var json;
    if (json = isJson(value)) {
        return json;
    }
    value = prepare_text(value);
    return value;
}

global.autoAssignFormLabel = function(target) {
	$(target).find('table input, table select, table textarea').each(function() {
		$(this).parent().prev().find('label').attr('for', $(this).attr('id'))
	});
}

global.formValidationProcess = function(item) {
    let formResult = true;
    var errors = formValidation(item);
    // Validation post process
    $.each(errors, function(key) {
        if (this && this.test) {
            // Issue - Remove error
            if (this.field.hasClass('tested--success')) {
                errors.splice(key, 1);
            }
            // Issue - Add error
            else if (this.field.hasClass('tested--error')) {
                errors[key]['message'] = this.field.data('error');
                formResult = false;
                return false;
            }
            // Issue - Require Ajax test
            else if (!this.field.hasClass('tested')) {
                if (!formResult) {
                    formResult = false;
                    var field = this.field;
                    var dataTest = {};
                    dataTest[this.field.attr('name')] = this.field.val();
                    $.ajax({
                        url: this.test,
                        form: form,
                        type: options.method,
                        data: JSON.stringify([dataTest]),
                        dataType: 'json',
                        contentType: "application/json; charset=utf-8",
                        success: function (data) {
                            // Test success
                            if (data.status == 'success') {
                                field.addClass('tested').addClass('tested--success');
                            }
                            // Test failure
                            else {
                                field.addClass('tested').addClass('tested--error').data('error', data.message);
                            }
                            ajaxForm(options);
                        },
                        error: function (data) {
                            // Test fatal
                            field.addClass('tested').addClass('tested--error').data('error', 'Validation impossible');
                        }
                    });
                    errors.splice(key, 1);
                    return false;
                }
            }
        }
    });

    // Display errors
    if (errors.length) {
        formShowError(item, errors);
        hideLoading();
        operation_message('Le formulaire contient des erreurs.', 'error');
        formResult = false;
    }

    return formResult;
}